import { IonSpinner } from '@ionic/react'

export default function Loading() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <IonSpinner name='dots' />
    </div>
  )
}
